import {
  CompWithFormProp,
  FormConfigProps,
} from '../../../constants/constants';
import { DynamicFormField } from '../../DynamicFormField';

export const subjectsNatureConfig: Record<string, FormConfigProps> = {
  usedVisualAid: {
    label: 'įvykiams iliustruoti naudojamos vaizdinės priemonės',
    value: 'usedVisualAid',
  },
  usedVideoContentReferences: {
    label:
      'pateikiamos nuorodos į mokomuosius vaizdo įrašus, dokumentinius filmus ir kt.',
    value: 'usedVideoContentReferences',
  },
  predeterminedGraphicOrganizers: {
    label: 'informacija sisteminama pildant numatytas grafines tvarkykles',
    value: 'predeterminedGraphicOrganizers',
  },
};

export const SubjectsNature = ({ form }: CompWithFormProp) => {
  return (
    <DynamicFormField
      formItemConfig={subjectsNatureConfig}
      formPathParams={['subject', 'block3', 'methods']}
      form={form}
    />
  );
};
